export default {
  documentTitle: 'ABA&WOWNOW',
}
